 // page init
jQuery(function(){
  initMobileNav();
});

// mobile menu init
function initMobileNav(){
  jQuery('.nav-toggle').click(function() {
    jQuery(this).toggleClass("active");
    jQuery("body").toggleClass("nav-active");
  });
  
  jQuery('.form-opener').click(function() {
    jQuery(this).toggleClass("form-active");
    jQuery(".form-block").toggleClass("form-active");
    jQuery(".form-search-block").toggleClass("form-active");
  });
}